import IconButton from '@mui/material/IconButton';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import './AddNewTag.scss';
// import infoIcon from '../../../assets/icons/info.svg';
import { useAuth0 } from '@auth0/auth0-react';
import Tooltip from '@mui/material/Tooltip';
import AuthService from 'Lib/API/Auth';
import { toastr } from 'react-redux-toastr';
import { useParams } from 'react-router-dom';
import ReactTags from 'react-tag-autocomplete';
import close from '../../../assets/icons/close.svg';

const AddNewTag = ({
  setOpenTag,
  openTag,
  setOpenEditTag,
  openEditTag,
  account,
  setRefresh,
  refresh,
  setLoad,
  load,
  user,
  selectedUserTag,
  type,
  apiType,
  addTagHandler,
  deleteTagHandler,
  modelType = true,
}) => {
  const effectiveApiType = apiType || type;
  const [tags, setTags] = useState(
    openEditTag
      ? account?.tags?.map((tag, idx) => ({ id: idx, name: tag }))
      : []
  );
  const [orgTags, setOrgTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState(
    account ? [...account?.tags] : [...selectedUserTag]
  );
  const [loading, setLoading] = useState(false);
  const [addNewOrgTag, setAddNewOrgTag] = useState(false);
  const [newOrgTag, setNewOrgTag] = useState('');
  const { id: accountId } = useParams();
  const [searchTag, setSearchTag] = useState('');
  const [suggestions, setSuggestions] = useState(
    account?.tags?.map((tag, idx) => ({ id: idx, name: tag }))
  );
  const reactTags = useRef();
  const { getAccessTokenSilently } = useAuth0();

  const onDelete = useCallback(
    (tagIndex) => {
      setTags(tags.filter((_, i) => i !== tagIndex));
    },
    [tags]
  );
  const onAddition = useCallback(
    (newTag) => {
      setTags([...tags, newTag]);
    },
    [tags]
  );
  function SuggestionComponent({ item, query }) {
    return (
      <span id={item.id} className={item.name === query ? 'match' : 'no-match'}>
        {item.name}
      </span>
    );
  }

  const addTag = async (tagObj) => {
    const tag = tagObj.title;
    const token = await getAccessTokenSilently();
    if (addTagHandler) {
      setSelectedTag([...selectedTag, tag]);
      setOrgTags(orgTags.filter((item) => item.title !== tag));
      addTagHandler(tag);
    } else if (account) {
      AuthService.addAccountTag({ accountId: account?._id, tag }, token)
        .then((res) => {
          setSelectedTag([...selectedTag, tag]);
          setOrgTags(orgTags.filter((item) => item.title !== tag));
        })
        .catch((err) => {
          console.log(err);
          toastr.error('Error', err?.data?.message || 'Something went wrong');
        });
    } else {
      AuthService.addContactTag({ contactId: user?._id, tag }, token)
        .then((res) => {
          setSelectedTag([...selectedTag, tag]);
          setOrgTags(orgTags.filter((item) => item.title !== tag));
        })
        .catch((err) => {
          console.log(err);
          toastr.error('Error', err?.data?.message || 'Something went wrong');
        });
    }
  };

  const deleteTag = async (tag) => {
    const token = await getAccessTokenSilently();
    if (addTagHandler) {
      setSelectedTag(selectedTag.filter((item) => item !== tag));
      setOrgTags([...orgTags, { title: tag }]);
      deleteTagHandler(tag);
    } else if (account) {
      AuthService.deleteAccountTag({ accountId: account?._id, tag }, token)
        .then((res) => {
          setSelectedTag(selectedTag.filter((item) => item !== tag));
          setOrgTags([...orgTags, { title: tag }]);
        })
        .catch((err) => {
          console.log('err: ', err);
          toastr.error('Error', err?.data?.message || 'Something went wrong');
        });
    } else {
      AuthService.deleteContactTag({ contactId: user?._id, tag }, token)
        .then((res) => {
          setSelectedTag(selectedTag.filter((item) => item !== tag));
          setOrgTags([...orgTags, { title: tag }]);
        })
        .catch((err) => {
          console.log('err: ', err);
          toastr.error('Error', err?.data?.message || 'Something went wrong');
        });
    }
  };

  const getTags = async () => {
    const token = await getAccessTokenSilently();
    setLoading(true);
    AuthService.getTags(
      effectiveApiType ? effectiveApiType : account ? 'account' : 'contact',
      type ? '' : account ? account?._id : user?._id,
      searchTag,
      token
    )
      .then((res) => {
        const tags = [...(res?.result || [])].sort((a, b) =>
          a.title > b.title ? 1 : -1
        );
        if (addTagHandler) {
          setOrgTags(
            tags.filter((item) => !selectedTag.find((tag) => tag === item.title))
          );
        } else {
          setOrgTags(tags);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
        setLoading(false);
      });
  };

  const validateSubmit = () => {
    if (!newOrgTag) return toastr.error('Error', 'Please enter tag name');
    if (
      orgTags.map((item) => item.title).find((tag) => tag === newOrgTag) ||
      selectedTag.find((tag) => tag === newOrgTag)
    )
      return toastr.error('Error', 'Tag already exist');
    createTag();
  };
  const createTag = async () => {
    const token = await getAccessTokenSilently();
    setLoading(true);
    AuthService.createTag(
      { title: newOrgTag, type: effectiveApiType ? effectiveApiType : account ? 'account' : 'contact' },
      token
    )
      .then((res) => {
        setOrgTags([...orgTags, { title: newOrgTag }]);
        setAddNewOrgTag(false);
        setNewOrgTag('');
        setLoading(false);
        if (addTagHandler) getTags();
        toastr.success('Success', 'Tag created successfully');
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
        setLoading(false);
      });
  };

  useEffect(() => {
    getTags();
  }, [searchTag]);

  return (
    <div className="AddNewTag_container">
      {modelType && (
        <div
          className="close_tag_modale"
          onClick={() => {
            setOpenTag(false);
            if (addTagHandler) return;
            setRefresh(!refresh);
          }}
        >
          {/* <img src={close} alt="close" /> */}x
        </div>
      )}
      <div className="add_tags_text">{'Add Tags'}</div>
      <div className="search__bar__tag">
        <p style={{ fontSize: '14px', fontWeight: '500' }}>Selected Tags</p>
        <div className="selected_tags">
          {selectedTag?.length > 0
            ? selectedTag
                ?.sort((a, b) =>
                  a?.toLowerCase().localeCompare(b?.toLowerCase())
                )
                ?.map((tag, idx) => (
                  <div className="tag" key={idx}>
                    {tag}
                    <span
                      style={{
                        marginLeft: '5px',
                        cursor: 'pointer',
                        fontSize: '12px',
                      }}
                      onClick={() => deleteTag(tag)}
                    >
                      x
                    </span>
                  </div>
                ))
            : ''}
        </div>
        <div className="search_tag">
          <input
            type="text"
            placeholder="Search Tags"
            className="form-control form-control-lg form-control-solid h-100 search-input mt-3"
            value={searchTag}
            onChange={(e) => setSearchTag(e.target.value)}
          />
        </div>
        <div className="org_tags_container">
          <div className="org_tags">
            {loading ? (
              <div>loading...</div>
            ) : orgTags.length === 0 ? (
              <div className="no_tags">No tags</div>
            ) : (
              orgTags
                ?.sort((a, b) => (a.title > b.title ? 1 : -1))
                ?.map((tag, idx) => (
                  <div className="tag" key={idx} onClick={() => addTag(tag)}>
                    {tag.title}
                    <span style={{ marginLeft: '5px', fontSize: '12px' }}>+</span>
                  </div>
                ))
            )}
          </div>
        </div>
        {!addNewOrgTag && (
          <div
            className={`add_org_tag mt-2 ${
              orgTags?.length > 40 ? 'addOrg_disabled' : ''
            }`}
            onClick={() => setAddNewOrgTag(true)}
          >
            + New Tag
          </div>
        )}
        {addNewOrgTag && (
          <>
            <div className="add_new_org_tag">
              <div className="addNewTag">New Tag</div>
              <input
                type="text"
                className="form-control form-control-lg form-control-solid h-100 search-input mt-3"
                placeholder="Tag Name"
                value={newOrgTag}
                onChange={(e) => setNewOrgTag(e.target.value)}
              />
            </div>
            <div className="add_orgTag_btn">
              <button
                className="btn btn-primary"
                onClick={validateSubmit}
                disabled={loading}
              >
                {loading ? (
                  <span
                    className="spinner spinner-white"
                    style={{ width: '20px' }}
                  ></span>
                ) : (
                  <span style={{ whiteSpace: 'nowrap' }}>Add Tag</span>
                )}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AddNewTag;
